export function openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
}

export function getFundUrl(fund){
    let mainDomain='';
    // Check if URL exists
    if (fund && fund.fundPageURL){
      return fund.fundPageURL;
    }
    // Set up the Morningstar URL
    if (fund){
      if (fund.type === 'ETF'){
        mainDomain='etfs';
      } else  if (fund.type === 'MF'){
        mainDomain='funds';
      }
      let subDomain ='';
      switch (fund.exchangeCode){
        case 'NASDAQ':
          subDomain='xnas';
          break;
        case 'Arca':
        case 'NYSE':
          subDomain='arcx';
          break;
        case 'BATS ECN - RDFD':
          subDomain='bats';
          break;
        default:
          subDomain='xnas';
      }
      return `https://www.morningstar.com/${mainDomain}/${subDomain}/${fund.ticker}/performance`;
    }
  }


// WEBPACK FOOTER //
// ./src/functions/functions.js